function sectionGeneralBreadcrumbsInit() {
  // Remove d-none class from all main filter menus
  $('.main-mediacenter-nav-mobile').removeClass('d-none');
  $('.generic-taxonomy-filters-mobile-main').removeClass('d-none');
  $('body').addClass('mobile-menu-enabled');
  $(window).scrollTop(0);
}
const generalBreadcrumbs = 'section.general-breadcrumbs';
document.querySelectorAll(generalBreadcrumbs + ' .filter').forEach(() => sectionGeneralBreadcrumbsInit);
